import { formatDefaultDate } from "../../../../../utils/DateUtils";

export const renderHospitalizationHistoryEntry = (
  hospitalizationHistory: any,
  _entry: any,
) => {
  const parts = [];
  const { period, serviceProvider, reasonReference } = hospitalizationHistory;

  if (period?.start) {
    parts.push(
      formatDefaultDate(
        new Date(period.start),
        period.extension?.[0]?.valueCode,
      ),
    );
  }

  if (serviceProvider?.display) {
    parts.push(serviceProvider.display);
  }

  if (reasonReference?.length > 0) {
    parts.push(reasonReference.map((r) => r?.display).join(" - "));
  }

  return <>{`⚬ ${parts.join(" · ")}`}</>;
};
